export const selectFolderDataParams = state => state.tree.folder_data.params
export const selectFolderData = state => state.tree.folder_data

export const selectCalendar = state => state.app.calendar

export const selectActiveFolder = state => state.tree.active_folder

export const selectAuthUser = state => state.app.auth.user

export const selectWorkingDays = state => state.app.auth.user.working_days

export const selectAllowedWorkingDays = state => state.app.auth.user.allowed_days

export const selectDates = state => state.app.dates

// stock

export const selectStockProducts = state => state.stock.products
export const selectStockFilterParams = state => state.stock.filter_params

export const selectIsAddWarehouseEnabled = state => state.app.addWarehouseEnabled
